<!-- <div class="toolbar" role="banner"> -->
<div style="max-width: 1000px; margin: auto;">
  <!-- <div class="left"> -->
      <div class="title">
    <img class="icon" src="assets/checkmark.png" alt="checkmark"/>
      <p>Welcome to Jen's To-Do App</p>
  </div>
</div>
      <!-- <span class="spacer"></span>

      <div id="about" class="right">
        <a class="navigation" (click)="onClickScroll('about')" >About
          <img class="A-icon" src="assets/Angular_Icon.png" alt="Angular Logo"/></a>
      </div> -->

<!-- </div> -->
